// @flow
import SettingProfileLink from './SettingProfileLink';

export default SettingProfileLink;



// WEBPACK FOOTER //
// ./src/components/settings/SettingProfileLink/index.js